<a mat-icon-button class="hide-in-mobile-view" color="primary"
(click)="darkThemeEnable = !darkThemeEnable; setTheme()">
    <mat-icon class="material-icons-outlined" [svgIcon]="darkThemeEnable ? 'sun_icon' : 'moon_icon'">
    </mat-icon>
</a>